import React from "react";
import Sidebar from "../Components/Dashboard/Sidebar";
import Header from "../Components/Dashboard/Header";

const DashboardLayout = ({ children }) => {
  return (
    <div className="w-full h-auto flex items-start justify-start overflow-x-hidden">
      <Sidebar />
      <div className="flex flex-col items-start justify-start w-full ml-[14%]">
        <Header />
        {children}
      </div>
    </div>
  );
};

export default DashboardLayout;
